// Roster Management Action Types
export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

export const FETCH_EMPLOYEES_BY_LOCATION_REQUEST = "FETCH_EMPLOYEES_BY_LOCATION_REQUEST";
export const FETCH_EMPLOYEES_BY_LOCATION_SUCCESS = "FETCH_EMPLOYEES_BY_LOCATION_SUCCESS";
export const FETCH_EMPLOYEES_BY_LOCATION_FAILURE = "FETCH_EMPLOYEES_BY_LOCATION_FAILURE";

export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

export const POST_ROSTER_REQUEST = "POST_ROSTER_REQUEST";
export const POST_ROSTER_SUCCESS = "POST_ROSTER_SUCCESS";
export const POST_ROSTER_FAILURE = "POST_ROSTER_FAILURE";

export const POST_SCHEDULE_REQUEST = "POST_SCHEDULE_REQUEST";
export const POST_SCHEDULE_SUCCESS = "POST_SCHEDULE_SUCCESS";
export const POST_SCHEDULE_FAILURE = "POST_SCHEDULE_FAILURE";

export const FETCH_ROSTER_DETAILS_REQUEST = "FETCH_ROSTER_DETAILS_REQUEST";
export const FETCH_ROSTER_DETAILS_SUCCESS = "FETCH_ROSTER_DETAILS_SUCCESS";
export const FETCH_ROSTER_DETAILS_FAILURE = "FETCH_ROSTER_DETAILS_FAILURE";

export const FETCH_ALL_ROSTER_DETAILS_REQUEST = "FETCH_ALL_ROSTER_DETAILS_REQUEST";
export const FETCH_ALL_ROSTER_DETAILS_SUCCESS = "FETCH_ALL_ROSTER_DETAILS_SUCCESS";
export const FETCH_ALL_ROSTER_DETAILS_FAILURE = "FETCH_ALL_ROSTER_DETAILS_FAILURE";

// UI State Action Types
export const CLEAR_SELECTED_EMPLOYEES = "CLEAR_SELECTED_EMPLOYEES";
export const SET_SELECTED_DATES = "SET_SELECTED_DATES";
export const SET_SELECTED_SHIFTS = "SET_SELECTED_SHIFTS";
export const SET_SELECTED_LOCATION = "SET_SELECTED_LOCATION";
export const CLEAR_ROSTER_STATE = "CLEAR_ROSTER_STATE";
export const RESET_POST_ROSTER_STATE = "RESET_POST_ROSTER_STATE";